import { c as _c } from "react/compiler-runtime";
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { operations } from './generated/couponsApi';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { COUPONS_URLS } from '@/constants/api';
import { apiCouponsFetcher } from '../fetcher';
import { useGetCmsEshopsLogosQuery } from '../sanity/generated';
import { Maybe } from '@/utils/types';
import { sanityLanguage } from '@/constants/language';
type CouponDetailBaseResponse = operations['couponDetail']['responses']['200']['content']['application/json'];
type CouponDetailExtendedResponse = Omit<CouponDetailBaseResponse, 'merchant'> & {
  merchant: CouponDetailBaseResponse['merchant'] & {
    logoUrl: Maybe<string>;
  };
  imageUrl?: Maybe<string>;
  linkToStore?: string;
};
export type CouponDetailResponse = CouponDetailExtendedResponse | undefined;
type QueryOpts = Omit<UseQueryOptions<unknown, unknown, CouponDetailResponse>, 'queryKey'>;
type QueryParams = operations['couponDetail']['parameters']['path'];
export function useCouponDetail(params, opts) {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = QUERY_KEYS.couponDetail(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = async () => {
      const res = await apiCouponsFetcher(COUPONS_URLS.couponDetail(params));
      const data = await res.json;
      const merchantName = data?.merchant.name;
      const defaultData = {
        ...data,
        merchant: {
          ...data?.merchant,
          logoUrl: undefined
        },
        imageUrl: data?.imageUrl,
        linkToStore: undefined
      };
      if (!merchantName) {
        return new Promise(resolve => resolve(defaultData));
      }
      const cmsResponse = await useGetCmsEshopsLogosQuery.fetcher({
        merchantNames: [merchantName],
        i18nLang: sanityLanguage
      })();
      const eshop = cmsResponse.allEshops[0];
      if (!eshop) {
        return defaultData;
      }
      const result = {
        ...data,
        merchant: {
          ...data.merchant,
          logoUrl: eshop.logo?.asset?.url
        },
        imageUrl: eshop?.heroImage?.asset?.url || data.imageUrl,
        linkToStore: eshop?.slug?.current || ""
      } satisfies CouponDetailExtendedResponse;
      return new Promise(resolve_0 => resolve_0(result));
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== opts || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...opts
    };
    $[4] = opts;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
}